import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WatabilightRouting } from "./watabilight.routing";
import { IdentificateService } from "./service/identificate.service";
import { AuthWatabilightService } from "./service/authWatabilight.service";
import { BookingService } from "./service/booking.service";
import { WatabilightService } from "./service/watabilight.service";
import { MatDialogModule } from "@angular/material/dialog";
import { WatabiPostDataFormattingService } from "./service/watabiPostDataFormatting.service";

@NgModule({
    imports: [
        CommonModule,
        WatabilightRouting,MatDialogModule
    ],
    providers: [
        IdentificateService,
        AuthWatabilightService,
        BookingService,
        WatabilightService,
        WatabiPostDataFormattingService,
    ]
}) export class WatabilightModule {}